import { render, staticRenderFns } from "./NewsTypeBar.vue?vue&type=template&id=32003882"
import script from "./NewsTypeBar.vue?vue&type=script&lang=js"
export * from "./NewsTypeBar.vue?vue&type=script&lang=js"
import style0 from "./NewsTypeBar.vue?vue&type=style&index=0&id=32003882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports